// extracted by mini-css-extract-plugin
module.exports = {"container":"ew9HREmG","item":"MRBOKB9C","dot":"aloiZjBT","label":"jIYB2k9v","value":"Pynm2924","positiveLine":"e4Yiviu3","negativeIndicator":"fV2GRg2Y","negativeLine":"jR9g_K7H"};